import React from 'react';

const HermesSelectComponent = (props) => {
  const onChangeEntity = (e) => {
    props.selectEntity(Number(e.currentTarget.value));
  }

  return (
    <div className="entity-select">
      <h4 key={1}><small>Select Entity:</small></h4>
      <select
        value={props.value === null ? '' : props.value}
        onChange={(e) => onChangeEntity(e)}>
        {props.entities.map((entity) => <option key={entity['key']} value={entity['key']}>{entity['value']}</option>)}
      </select>
    </div>

  );
};

export default HermesSelectComponent;

//<option key={-99} value={-99}>{''}</option>
